import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const ASSET_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('assetNumber', 'Entity.Asset.AssetNumber')
    .required()
    .minLength(1)
    .maxLength(25)
    .build(),
  FieldBuilder
    .text('name', 'Entity.Asset.Name')
    .minLength(1)
    .maxLength(500)
    .build(),
];

export const ASSET_CONFIG = {
  entityName: 'Asset',
  localizationKey: 'Controlling::Entity.Asset',
  fields: ASSET_FIELDS,
  permission: 'ControllingContract.Assets',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Contracts + MENU_NAME_SUFFIX,
};
